import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  OnChanges
} from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { CpmService } from 'app/service/cpm.service'
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service'
import { DomSanitizer } from '@angular/platform-browser'
import { environment } from 'environments/environment'
import { SetAttendeesComponent } from '../set-attendees/set-attendees.component'
import { CompanyAttendeesComponent } from '../company-attendees/company-attendees.component'
import { StatusComponent } from '../status/status.component'

@Component({
  selector: 'app-crm-case',
  templateUrl: './crm-case.component.html',
  styleUrls: ['./crm-case.component.scss']
})
export class CrmCaseComponent implements OnInit, OnChanges {
  @Input() createFormData
  @Output() onFinished: EventEmitter<any> = new EventEmitter()

  @ViewChild('template') template: TemplateRef<any>
  @ViewChild('setAttendeesComponent')
  setAttendeesComponent: SetAttendeesComponent
  @ViewChild('companyAttendeesComponent')
  companyAttendeesComponent: CompanyAttendeesComponent
  @ViewChild('statusComponent') statusComponent: StatusComponent

  modalRef: BsModalRef

  searchContinueCaseResults: Array<Object> = []
  meetingObjectiveList: Array<Object> = []
  setEmployeeList: Array<Object> = []
  statusList: Array<Object> = []
  departmentList: Array<Object> = []

  employeeSearchResult: Array<Object> = []
  companyContactList: Array<Object> = []

  presentationFile: File = null
  factsheetFile: File = null
  memoFile: File = null

  iframeSource

  isFormValid: Boolean = true

  securityProfile
  caseForm: FormGroup = new FormGroup({})

  constructor(
    private cpmService: CpmService,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.buildForm()
  }

  async getCommonData() {
    await Promise.all([
      this.cpmService.getCaseStatusList(),
      this.cpmService.getMeetingObjective(),
      this.cpmService.getEmployeeList()
    ]).then(
      ([
        statusListResponse,
        meetingObjectiveListResponse,
        employeeListResponse
      ]) => {
        this.statusList = statusListResponse
        this.meetingObjectiveList = meetingObjectiveListResponse
        this.setEmployeeList = employeeListResponse
      }
    )
  }

  buildForm(): void {
    this.caseForm = this.fb.group({
      meetingObjectiveControl: [''],
      summaryControl: ['', Validators.required],
      otherAttendee: [''],
      jointDepartment: [{ value: '', disabled: true }],
      caseStatus: [''],
      department: [''],
      serviceStartTime: ['08:00', Validators.compose([
        Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')
      ])],
      serviceEndTime: ['17:00', Validators.compose([
        Validators.pattern('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$')
      ])],
    })
  }

  get serviceStartTime() { return this.caseForm.get('serviceStartTime'); }
  get serviceEndTime() { return this.caseForm.get('serviceEndTime'); }

  ngOnChanges() {
    this.initialData()
  }

  async fetchingSecurityCase() {
    await this.getCommonData()
    await Promise.all([
      this.cpmService.getCrmCase(
        this.createFormData.securitySymbol,
        'securitySymbol'
      ),
      this.cpmService.getSecurityProfile(this.createFormData.securitySymbol),
      this.cpmService.getCompanyContactList(this.createFormData.securitySymbol),
      this.cpmService.getForwardingDepartment(
        this.createFormData.securitySymbol
      ),
      this.cpmService.getAEList(this.createFormData.securitySymbol)
    ]).then(
      ([
        continueCaseResponse,
        securityProfileResponse,
        companyContactResponse,
        forwardingDepartmentResponse,
        symbolAEList
      ]) => {
        this.searchContinueCaseResults = continueCaseResponse
        this.securityProfile = securityProfileResponse
        this.companyContactList = companyContactResponse
        this.departmentList = this.getDepartmentWithAEName(
          forwardingDepartmentResponse,
          symbolAEList
        )
      }
    )
  }

  async initialData() {
    await this.fetchingSecurityCase()
    if (!this.createFormData) {
      return
    }

    this.caseForm.get('meetingObjectiveControl').setValue(1)
    this.setAttendeeSetting()
    this.companyAttendeeSetting()
    this.statusSetting()
  }

  isContinueCase() {
    return this.createFormData === undefined
      ? false
      : this.createFormData.caseType === 'C'
  }

  changeJointDepartment(event): void {
    this.caseForm.get('jointDepartment').setValue(event)
  }

  setAttendeeSetting(): void {
    this.setAttendeesComponent.setEmployeeList = this.setEmployeeList
    this.setAttendeesComponent.initialCreate()
  }

  companyAttendeeSetting(): void {
    this.companyAttendeesComponent.companyContactList = this.companyContactList
    this.companyAttendeesComponent.initialCreate()
  }

  statusSetting(): void {
    this.statusComponent.statusList = this.statusList
    this.statusComponent.departmentList = this.departmentList
    this.statusComponent.statusId = 1
    this.statusComponent.departmentId = null
    this.statusComponent.initial()
  }

  getDepartmentWithAEName(department, symbolAEList): Array<Object> {
    return department.map(x => {
      const ae = symbolAEList.find(e => e.department === x.shortName)
      x['aeName'] = ae.firstNameThai + ' ' + ae.lastNameThai
      return x
    })
  }

  get securitySymbol(): String {
    return this.createFormData === undefined
      ? ''
      : this.createFormData.securitySymbol
  }

  get companyNameThai(): String {
    return this.securityProfile === undefined
      ? ''
      : this.securityProfile.companyNameThai
  }

  get meetingDate(): String {
    return this.createFormData === undefined
      ? ''
      : this.createFormData.meetingDate
  }

  get caseType(): String {
    if (this.createFormData !== undefined) {
      return this.createFormData.caseType === 'C' ? 'Continue case' : 'New case'
    }
    return null
  }

  get castId(): String {
    if (this.createFormData !== undefined) {
      return this.createFormData.caseId === undefined
        ? '[New Case]'
        : this.createFormData.caseId
    }
    return null
  }

  get continueCaseId(): String {
    return this.createFormData.continueCaseId
  }

  prepareData(): FormData {
    const formData = new FormData()
    if (this.presentationFile) {
      formData.append('presentationFile', this.presentationFile)
    }
    if (this.factsheetFile) {
      formData.append('factsheetFile', this.factsheetFile)
    }
    if (this.memoFile) {
      formData.append('memoFile', this.memoFile)
    }
    formData.append(
      'crmCase',
      new Blob(
        [
          JSON.stringify({
            caseStatusId: this.statusComponent.currentStatus,
            continueDepartmentId: this.statusComponent.currentDepartment,
            companyIdPsims: this.securityProfile.companyIdPsims,
            id: this.checkNewCaseOrContinueCase(this.createFormData.id), // id === null is add new case
            continueCaseId: this.getContinueCaseId(),
            jointDepartmentFlag: this.caseForm.get('jointDepartment').value,
            meetingDate: this.getDateISO(this.createFormData.meetingDate),
            meetingObjectiveId: this.caseForm.get('meetingObjectiveControl')
              .value,
            summary: this.caseForm.get('summaryControl').value,
            type: this.createFormData.caseType,
            setAttendee: this.setAttendeesComponent.getAllSetAttendees,
            companyAttendee: this.companyAttendeesComponent
              .getAllCompanyAttendees,
            otherAttendee: this.caseForm.get('otherAttendee').value,
            continueAction: null,
            serviceStartTime: this.caseForm.get('serviceStartTime').value,
            serviceEndTime: this.caseForm.get('serviceEndTime').value
          })
        ],
        { type: 'application/json' }
      )
    )
    return formData
  }

  onTimeInput(event) {
    event.target.value = event.target.value.replace(/[^\d\:]+/g, '')
  }

  async onSubmit() {
    this.isFormValid = this.validateForm()
    if (!this.isFormValid) {
      return
    }
    if (this.createFormData) {
      await this.cpmService
        .putCaseData(this.prepareData())
        .then(response => {
          this.finished(response)
        })
        .catch(() => {
          this.finished({
            message: 'Something wrong when try to save.',
            status: 'ERROR'
          })
        })
    } else {
      alert('Something went wrong!')
    }
  }

  finished(response): void {
    if (response) {
      this.onFinished.emit(response)
    } else {
      this.onFinished.emit({ message: 'Cancel action.', status: 'WARNNING' })
    }
  }

  validateForm(): Boolean {
    if (this.caseForm.valid) {
      return true
    }
    return false
  }

  checkNewCaseOrContinueCase(id): Number {
    if (id === undefined) {
      return null
    }
    return id
  }

  getDateISO(date): String {
    return new Date(date).toISOString()
  }

  changePresentation(event): void {
    if (event.target.files.length > 0) {
      this.presentationFile = event.target.files[0]
    }
  }

  changeFactsheet(event): void {
    if (event.target.files.length > 0) {
      this.factsheetFile = event.target.files[0]
    }
  }

  changeMemo(event): void {
    if (event.target.files.length > 0) {
      this.memoFile = event.target.files[0]
    }
  }

  getContinueCaseId(): Number {
    const idOfContinueCase = this.searchContinueCaseResults.find(
      x => x['caseId'] === this.createFormData.continueCaseId
    )
    return idOfContinueCase !== undefined ? idOfContinueCase['id'] : null
  }

  get getPresentationFile(): Object {
    if (this.presentationFile) {
      return {
        fileName: this.presentationFile.name,
        fileItem: this.presentationFile
      }
    }
    return { fileName: 'No file was chosen.', fileItem: null }
  }

  get getFactsheetFile(): Object {
    if (this.factsheetFile) {
      return { fileName: this.factsheetFile.name, fileItem: this.factsheetFile }
    }
    return { fileName: 'No file was chosen.', fileItem: null }
  }

  get getMemoFile(): Object {
    if (this.memoFile) {
      return { fileName: this.memoFile.name, fileItem: this.memoFile }
    }
    return { fileName: 'No file was chosen.', fileItem: null }
  }

  generateModal(fileItem): void {
    this.readFile(fileItem).then(result => {
      const iframe = document.querySelector('iframe')
      const resultAsString = result.toString()
      iframe.src = resultAsString
      if (
        resultAsString.startsWith('data:application/pdf') ||
        resultAsString.startsWith('data:image')
      ) {
        return
      }
      setTimeout(this.modalRef.hide, 200)
    })
  }

  readFile(file): Promise<any> {
    return new Promise((resolve, reject) => {
      const fr = new FileReader()
      fr.onload = () => {
        resolve(fr.result)
      }
      fr.readAsDataURL(file)
    })
  }

  openModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
  }

  closeModal(): void {
    this.modalRef.hide()
  }

  previewFile(fileForPreview): void {
    this.openModal(this.template)
    switch (fileForPreview) {
      case 'presentation': {
        this.generateModal(this.presentationFile)
        break
      }
      case 'factsheet': {
        this.generateModal(this.factsheetFile)
        break
      }
      case 'memo': {
        this.generateModal(this.memoFile)
        break
      }
    }
  }

  closeModalWithFileTypeCondition(): void {
    setTimeout(
      function (modal) {
        const numberOfElementInIframe = $('iframe').contents().length
        if (numberOfElementInIframe < 3) {
          setTimeout(modal.hide, 200)
        }
      },
      200,
      this.modalRef
    )
  }

  oldPresentation(id): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=crm_presentation&id=${id}`
    )
    this.closeModalWithFileTypeCondition()
  }

  oldFactsheet(caseId): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=crm_factsheet&id=${caseId}`
    )
    this.closeModalWithFileTypeCondition()
  }

  oldMemo(caseId): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=crm_memo&id=${caseId}`
    )
    this.closeModalWithFileTypeCondition()
  }

  get hasPresentationFile(): Boolean {
    return this.presentationFile === null ? false : true
  }

  get hasFactsheetFile(): Boolean {
    return this.factsheetFile === null ? false : true
  }

  get hasMemoFile(): Boolean {
    return this.memoFile === null ? false : true
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/crm-case/crm-case.component.ts